// src/components/Sidebar/ClientMenuItems.ts
import AddYourCompany from "assets/navigationIcons/add-company.svg?react";
import Companies from "assets/navigationIcons/companies.svg?react";
import CreditLimitRequest from "assets/navigationIcons/creditLimitRequests.svg?react";
import DashboardIcon from "assets/navigationIcons/dashboard.svg?react";
import EwalletIcon from "assets/navigationIcons/ewallet.svg?react";
import Invoices from "assets/navigationIcons/invoice.svg?react";
import SelectYourAccount from "assets/navigationIcons/select-account.svg?react";
import TradingRelationships from "assets/navigationIcons/tradingRelationships.svg?react";
import Users from "assets/navigationIcons/users.svg?react";
import { EditNote } from "@mui/icons-material";
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

import {
  ADD_COMPANY,
  BOOK_MEETING,
  ADD_PARTNER,
  BILLINGS_LINK,
  COMPANIES,
  DASHBOARD,
  NEW_USER,
  ONBOARDING,
  ONBOARDED,
  PRESALES,
  REGISTERED,
  REGISTER_FOR_FINANCING,
  SELECT_ACCOUNT,
  TERMSHEETS_LINK,
  TP_ADDED,
  TR_LINK,
  USERS_LINK,
} from "codes";
import { useTranslation } from "react-i18next";
import { menuStyling as styling } from "styles/theme";
import { useAppSelector } from "redux/hooks";

const ClientMenuItems = () => {
  const { t } = useTranslation();
  const APP_STATE = useAppSelector((state) => state.appState.value);

  switch (APP_STATE) {
    case NEW_USER:
      return [
        {
          title: `${t("add-your-company")}`,
          icon: AddYourCompany,
          ...styling,
          link: ADD_COMPANY,
        },
        {
          title: `${t("Book a meeting")}`,
          icon: CalendarMonthIcon,
          ...styling,
          link: BOOK_MEETING,
        },
      ];
    case SELECT_ACCOUNT:
      return [
        {
          title: `Select Your Account`,
          icon: SelectYourAccount,
          ...styling,
          link: "/accounts",
        },
      ];
    case REGISTERED:
    case PRESALES:
    case TP_ADDED:
      return [
        {
          title: t("dashboard"),
          icon: DashboardIcon,
          ...styling,
          link: DASHBOARD,
        },
        {
          title: "Company Profile",
          icon: Companies,
          ...styling,
          link: COMPANIES,
        },
        {
          title: "Request Financing",
          icon: CreditLimitRequest,
          ...styling,
          link: REGISTER_FOR_FINANCING,
        },
      ];
    case ADD_PARTNER:
      return [
        {
          title: t("trade-partners"),
          icon: TradingRelationships,
          ...styling,
          link: TR_LINK,
        },
      ];
    case ONBOARDING:
      return [
        {
          title: t("dashboard"),
          icon: DashboardIcon,
          ...styling,
          link: DASHBOARD,
        },
        {
          title: "Company Profile",
          icon: Companies,
          ...styling,
          link: COMPANIES,
        },
        {
          title: "Termsheets",
          icon: EditNote,
          ...styling,
          link: TERMSHEETS_LINK,
        },
        {
          title: "Billings",
          icon: AccountBalanceWalletIcon,
          ...styling,
          link: BILLINGS_LINK,
        },
        {
          title: t("trade-partners"),
          icon: TradingRelationships,
          ...styling,
          link: TR_LINK,
        },
        {
          title: "Users",
          icon: Users,
          ...styling,
          link: USERS_LINK,
        },
        {
          title: `${t("Book a meeting")}`,
          icon: CalendarMonthIcon,
          ...styling,
          link: BOOK_MEETING,
        },
      ];
    case ONBOARDED:
      return [
        {
          title: t("dashboard"),
          icon: DashboardIcon,
          ...styling,
          link: DASHBOARD,
        },
        {
          title: "Company Profile",
          icon: Companies,
          ...styling,
          link: COMPANIES,
        },
        {
          title: "Termsheets",
          icon: EditNote,
          ...styling,
          link: TERMSHEETS_LINK,
        },
        {
          title: t("trade-partners"),
          icon: TradingRelationships,
          ...styling,
          link: TR_LINK,
        },
        {
          title: t("invoices"),
          icon: Invoices,
          ...styling,
          link: "/invoices",
        },
        {
          title: "E-wallet",
          icon: EwalletIcon,
          ...styling,
          link: "/client-ewallet",
        },
        {
          title: "Users",
          icon: Users,
          ...styling,
          link: USERS_LINK,
        },
      ];
    default:
      return [
        {
          title: `${t("add-your-company")}`,
          icon: AddYourCompany,
          ...styling,
          link: ADD_COMPANY,
        }
      ];
  }
};

export default ClientMenuItems;
